
import { defineComponent, PropType } from 'vue'
import api from '@/utils/incitefulApi'
import PaperHero from '../PaperHero.vue'
import GraphView from '../GraphView.vue'
import { Paper, PaperConnector } from '@/types/incitefulTypes'
import navigation from '@/navigation'
import { PaperModalOptions } from '@/types/modalTypes'
import { GraphData } from '@/types/graphTypes'
import { addToLitReviewHelper } from '@/utils/emitHelpers'

export default defineComponent({
  name: 'PaperModalContent',
  components: {
    PaperHero,
    GraphView
  },
  data() {
    return {
      paper: undefined as Paper | undefined,
      connectingResults: undefined as PaperConnector | undefined,
      loaded: false
    }
  },
  props: {
    options: Object() as PropType<PaperModalOptions>
  },
  computed: {
    graphData(): GraphData | undefined {
      const type = 'connector'

      if (this.connectingResults === undefined) {
        return undefined
      }

      return {
        type,
        papers: this.connectingResults.papers,
        connections: this.connectingResults.connections,
        paths: this.connectingResults.paths,
        toId: this.options?.paperId,
        fromId: this.options?.connectTo,
        modalOptions: {
          previousScreen: this.options,
          connectTo: this.options?.connectTo
        }
      }
    }
  },
  mounted(): void {
    if (!this.options?.paperId) {
      this.paper = undefined
    } else {
      api.getPaper(this.options.paperId).then(paper => (this.paper = paper))
    }
    if (this.options?.connectTo) {
      this.connectPapers(this.options.connectTo, this.options.paperId)
    } else {
      this.connectingResults = undefined
    }
  },
  watch: {
    options(newVal: PaperModalOptions, oldVal: PaperModalOptions) {
      if (newVal.paperId !== oldVal.paperId) {
        api.getPaper(newVal.paperId).then(paper => (this.paper = paper))
        if (newVal.connectTo) {
          this.connectPapers(newVal.connectTo, newVal.paperId)
        }
      } else if (newVal.connectTo !== oldVal.connectTo) {
        if (newVal.connectTo) {
          this.connectPapers(newVal.connectTo, newVal.paperId)
        } else {
          this.connectingResults = undefined
        }
      }
    },
    connectTo(newVal: string, oldVal: string) {
      if (newVal !== oldVal) {
        if (this.options?.connectTo) {
          this.connectPapers(this.options.connectTo, this.options.paperId)
        } else {
          this.connectingResults = undefined
        }
      }
    }
  },
  emits: ['clearModal', 'back'],
  methods: {
    connectPapers(from: string, to: string): void {
      this.loaded = false
      api.connectPapers(from, to, false).then(results => {
        this.connectingResults = results
        this.loaded = true
      })
    },
    goToLitConnector(): void {
      if (this.graphData) {
        this.$router.push({
          name: 'LitConnector',
          query: {
            to: this.graphData.toId?.toString(),
            from: this.graphData.fromId?.toString()
          }
        })
        this.$emit('clearModal')
      }
    },
    addToLitReview(): void {
      if (this.options !== undefined) {
        addToLitReviewHelper(this.options.paperId)
        this.back()
      }
    },
    goToPaper(): void {
      if (this.options !== undefined) {
        this.$router.push({
          path: navigation.getPaperUrl(this.options.paperId)
        })

        this.$emit('clearModal')
      }
    },
    back(): void {
      this.$emit('back')
    }
  }
})
